<div
  class="container-fluid m-0 px-3 py-2 block"
  [ngClass]="{ 'theme-darkk': themeService.flag }"
>
  <div
    class="
      about
      row row-12
      justify-content-center
      align-items-center
      my-3
      wave
      mx-auto
    "
    [ngClass]="{
      'canvas-bg-dark wave-dark': themeService.flag,
      'canvas-bg-light': !themeService.flag
    }"
  >
    <div
      class="
        col col-12 col-md-4
        p-2
        m-1
        justify-content-center
        align-items-center
        text-center
      "
    >
      <img
        [src]="dataService.info.image_urls.about"
        alt="image"
        class="img-fluid myavatar depth my-3"
      />
    </div>
    <div
      class="
        col col-12 col-md-7
        py-2
        px-3
        m-1
        justify-content-center
        align-items-center
      "
    >
      <div
        class="about-text text-justify p-3 depth"
        [ngClass]="{
          'bg-white': !themeService.flag,
          'bg-dark': themeService.flag
        }"
      >
        <h2 class="font-pacifico">
          <span
            class="text-underline cursor-pointer"
            (click)="navigate('\about')"
            >About Me</span
          >.
        </h2>
        <p class="text-about font-oxygen mt-2">
          Hi, I am {{ dataService.info.name }}, a {{ age }} years old Developer
          living in
          <a
            href="https://en.wikipedia.org/wiki/Jaipur"
            target="_blank"
            rel="noopener noreferrer"
            >{{ dataService.info.location }}</a
          >.
        </p>
        <p class="text-about font-oxygen">
          I am a Developer by Profession and a Musician by Passion! Currently
          working as a
          <strong
            >Software Development Engineer 1 at
            <a
              href="https://blinkit.com/"
              target="_blank"
              rel="noopener noreferrer"
              >Blinkit</a
            ></strong
          >.
        </p>
        <p class="text-about font-oxygen">
          You can find me in front of my laptop during office hours! Playing my instruments, going out for a bike ride, and cubing are my favourite passtime. 
        </p>
        <p class="text-about font-oxygen">
          Have a look at my
          <a
            href="https://mysticalcoder.com/"
            target="_blank"
            rel="noopener noreferrer"
            >Blogs</a
          >, <a routerLink="/skills">Skills</a> or just connect with me on
          <a
            href="https://www.linkedin.com/in/tanay-toshniwal/"
            target="_blank"
            rel="noopener noreferrer"
            >LinkedIn</a
          >. I am always excited to do business with like minded people, lets
          discuss over <a routerLink="/contact">coffee</a>.
        </p>
      </div>
      <div class="d-flex justify-content-center">
        <button
          type="button"
          class="btn mybtn depth m-3 mt-4"
          [ngClass]="{ 'mybtn-dark': themeService.flag }"
          (click)="navigate('/about')"
        >
          <fa-icon [icon]="faInfoCircle"></fa-icon>
          <span class="h5 ml-2">Know More...</span>
        </button>
      </div>
    </div>
  </div>
  <div class="row row-12 justify-content-center align-items-center text-center">
    <div
      class="
        counts
        col col-10 col-lg-3 col-md-4 col-sm-6
        m-3
        justify-content-center
        align-items-center
        depth
      "
      *ngFor="let count of dataService.countUps"
    >
      <h1 class="breath" [countUp]="count.countE">0</h1>
      <p style="font-size: 18px">{{ count.text }}</p>
    </div>
  </div>
</div>
